<template>
  <Layout>
    <Content :style="{'padding': '10px'}">
      <Card :style="{'padding':'0px 5px','margin-bottom':'5px'}">
        <span class="search_span_width">
		      <span class="search_span_width_part1">用户ID：</span>
          <Input v-model="search.user_id" placeholder="用户ID" clearable :style="{'width':'80px'}"></Input>
        </span>
        <span class="search_span_width">
          <span class="search_span_width_part1">并发类型：</span>
          <Select v-model="search.recharge_type" clearable style="width:260px">
             <Option :value='30'>专属并发</Option>
             <Option :value='31'>通用并发</Option>
             <Option :value='34'>共享并发</Option>
             <Option :value='32'>4K并发</Option>
             <Option :value='33'>照片并发</Option>
          </Select>
	        </span>
        <Button type='primary' icon="ios-search" :style="{'margin-left':'20px'}" @click="getList(1)">搜索</Button>  <span style="margin-left:10px;"><b>总计：{{recordTotal}} 个</b></span>
      </Card>

      <Card id="tableContent" >
          <Table :columns="tableColumns" :data="tableData"></Table>
          <Page :total="recordTotal" :current="page" :page-size=pageSize :show-elevator="true" @on-change="getList"/>
      </Card>
    </Content>
  </Layout>
</template>
<script>
export default {
  data(){
    return {
      search : {
        id:''
      },
      productList:[],
      showmodal:false,
      showtemplatemodal:false,
      tableData:[],
      recordTotal:0,
      page:1,
      pageSize: 10,
      tableColumns:[
        { title: '用户ID', key: 'user_id', align: 'center' },
        { title: '用户', key: 'nickname', align: 'center' },
        { title: '并发类型', key: 'recharge_type', align: 'center',render:(h,params) =>{
            var name = '未知';
            if(params.row.recharge_type==30){
              name = '专属并发';
            }
            if(params.row.recharge_type==31){
              name = '通用并发';
            }
            if(params.row.recharge_type==32){
              name = '4K并发';
            }
            if(params.row.recharge_type==33){
              name = '照片并发';
            }
            if(params.row.recharge_type==34){
              name = '共享并发';
            }
            return h('span',{},name);
          }
        },
        { title: '手机号', key: 'mobile', align: 'center' },
        { title: '邮箱', key: 'email', align: 'center' },
        { title: '权益(并发或次数)', key: 'recharge_time', align: 'center' },
        { title: '开始时间', key: 'start_time', align: 'center' },
        { title: '结束时间', key: 'end_time', align: 'center' },
        { title: '创建时间', key: 'created_at', align: 'center' },

      ],
    }
  },
  mounted(){
    this.getList();
    this.getProductTypeList();
  },
  computed:{

  },
  methods:{
    getList(page=this.page) {
      this.page = page;
      let p = {'page' : page, 'page_size': this.pageSize};
      let params = Object.assign(this.search, p);
      this.http.get('admin/user/getRealTimeConcurrency',{params:params}).then(response=>{
        let data=response.data;
        if(data.code!==0){
          alert(data.message);
        } else{
          this.tableData = data.data.list;
          this.recordTotal = data.data.total;
        }
      }).catch(()=>{
        this.$Message.error('网络错误');
      });
    },
  }

}
</script>
